<main class="send-sms">
  <h1 class="main-wrapper"> Send a text message </h1>
  <section [attr.aria-label]="currentStep" class="step-section">
    <div class="main-wrapper progress-bar">
      <app-stepindicator [stepIndicators]="steps" [displayIndicator]=true [sessionName]="'sendSMS'"></app-stepindicator>
      <section class="steps-container">
        <div *ngIf="errorMessage.show" class="alert valign-children-middle error-container">
          <div class="alert-error">
            <i class="icon-badgealert" role="img" aria-label="Alert" tabindex="0"></i>
          </div>
          <div>{{errorMessage.heading}} <span class="message">{{errorMessage.subHeading}}</span></div>
          <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close"></div>
        </div>
        <router-outlet></router-outlet>
      </section>
    </div>
  </section>
</main>
<app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>